(function () {
  "use strict";

  if (window.__giftCardBuilderLoaded) return;
  window.__giftCardBuilderLoaded = true;

  var init = function (root) {
    var toggle = root.querySelector("[data-gift-toggle]");
    var fields = root.querySelector("[data-gift-fields]");
    var offset = root.querySelector("[data-gift-offset]");
    var message = root.querySelector("[data-gift-message]");
    var counter = root.querySelector("[data-gift-counter]");
    var sendOn = root.querySelector("[data-gift-send-on]");
    var errors = root.querySelector("[data-gift-errors]");
    var designInput = root.querySelector("[data-gift-design-input]");
    var designImageInput = root.querySelector("[data-gift-design-image-input]");
    var previewImage = root.querySelector("[data-gift-preview-image]");
    var previewAmount = root.querySelector("[data-gift-preview-amount]");
    var emailInput = root.querySelector("[name='properties[Recipient email]']");

    if (toggle && fields) {
      toggle.addEventListener("change", function () {
        var on = toggle.checked;
        fields.disabled = !on;
        fields.hidden = !on;
        if (!on && errors) {
          errors.hidden = true;
          errors.textContent = "";
        }
        if (!on && emailInput) {
          emailInput.style.borderColor = "";
          emailInput.style.boxShadow = "";
        }
      });
    }

    if (offset) offset.value = String(new Date().getTimezoneOffset());

    if (message && counter) {
      var max = parseInt(message.getAttribute("maxlength"), 10) || 200;
      var updateCounter = function () {
        counter.textContent = max - message.value.length + " characters left";
      };
      message.addEventListener("input", updateCounter);
      updateCounter();
    }

    if (sendOn) {
      var iso = function (d) {
        return d.toISOString().slice(0, 10);
      };
      var today = new Date();
      var maxDate = new Date(today.getTime() + 90 * 864e5);
      sendOn.min = iso(today);
      sendOn.max = iso(maxDate);
    }

    root.querySelectorAll("[data-gift-design]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll("[data-gift-design]").forEach(function (other) {
          other.classList.remove("is-selected");
          other.setAttribute("aria-checked", "false");
        });
        btn.classList.add("is-selected");
        btn.setAttribute("aria-checked", "true");
        
        var imgUrl = btn.getAttribute("data-design-image") || "";
        if (designInput) designInput.value = btn.getAttribute("data-design-name") || "";
        if (designImageInput) designImageInput.value = imgUrl;
        if (previewImage && imgUrl) previewImage.src = imgUrl;
      });
    });

    // 1. Price Badge Live Preview Sync (Instant Direct Target Sync)
    if (previewAmount) {
      var extractPriceText = function (text) {
        if (!text) return null;
        var match = text.trim().match(/[\$\£\€\¥\₹]?\s?\d+([.,]\d{2})?/);
        return match && match[0] ? match[0].trim() : null;
      };

      var setPreviewPrice = function (priceStr) {
        if (priceStr) {
          previewAmount.textContent = priceStr;
        }
      };

      var syncPriceFromDom = function () {
        var productContainer = root.closest("[data-product-id], .product-form, section, body") || document.body;

        var selectedPill = productContainer.querySelector(
          ".product-variant-picker label.selected, .product-variant-picker input:checked + label, .product-variant-picker [aria-checked='true'], .product-variant-picker .pill.selected"
        );
        if (selectedPill) {
          var p1 = extractPriceText(selectedPill.textContent);
          if (p1) {
            setPreviewPrice(p1);
            return;
          }
        }

        var selectOption = productContainer.querySelector("select[name='id'] option:checked, select[data-variant-picker-select] option:checked");
        if (selectOption) {
          var p2 = extractPriceText(selectOption.getAttribute("data-price") || selectOption.textContent);
          if (p2) {
            setPreviewPrice(p2);
            return;
          }
        }

        var mainPrice = productContainer.querySelector(".price, .product-price, .price__current, [data-product-price]");
        if (mainPrice && !root.contains(mainPrice)) {
          var p3 = extractPriceText(mainPrice.textContent);
          if (p3) {
            setPreviewPrice(p3);
          }
        }
      };

      setTimeout(syncPriceFromDom, 50);

      document.addEventListener(
        "click",
        function (e) {
          var pill = e.target.closest(".pill, label[for], .product-variant-picker__item, [data-variant-picker-input]");
          if (pill) {
            var clickedPrice = extractPriceText(pill.textContent);
            if (clickedPrice) {
              setPreviewPrice(clickedPrice);
            } else {
              setTimeout(syncPriceFromDom, 50);
            }
          }
        },
        true
      );

      window.addEventListener("variant:change", function (evt) {
        var variant = evt.detail && (evt.detail.variant || evt.detail.selectedVariant);
        if (variant && typeof variant.price !== "undefined") {
          try {
            var formatted = new Intl.NumberFormat(document.documentElement.lang || "en", {
              style: "currency",
              currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "AUD",
            }).format(variant.price / 100);
            setPreviewPrice(formatted);
          } catch (err) {
            syncPriceFromDom();
          }
        } else {
          syncPriceFromDom();
        }
      });
      document.addEventListener("change", function () {
        setTimeout(syncPriceFromDom, 20);
      });
    }

    // 2. Form Input Sync & Email Validation on Add to Cart
    var form = root.closest("form") || document.querySelector("form[action*='/cart/add']");
    if (!form) {
      var formId = designInput ? designInput.getAttribute("form") : null;
      if (formId) form = document.getElementById(formId);
    }

    if (form) {
      var syncFormProperties = function () {
        // Sync design input & image input
        var propsToSync = [
          { input: designInput, name: "properties[Design]" },
          { input: designImageInput, name: "properties[_design_image]" }
        ];

        propsToSync.forEach(function (item) {
          if (item.input && item.input.value) {
            var existing = form.querySelector("input[name='" + item.name + "']");
            if (!existing) {
              existing = document.createElement("input");
              existing.type = "hidden";
              existing.name = item.name;
              form.appendChild(existing);
            }
            existing.value = item.input.value;
          }
        });

        // Sync recipient fields if enabled
        if (toggle && toggle.checked) {
          root.querySelectorAll("input[name^='properties['], textarea[name^='properties[']").forEach(function (inp) {
            if (inp.disabled || !inp.name || !inp.value) return;
            var existing = form.querySelector("input[name='" + inp.name + "'], textarea[name='" + inp.name + "']");
            if (!existing) {
              existing = document.createElement("input");
              existing.type = "hidden";
              existing.name = inp.name;
              form.appendChild(existing);
            }
            existing.value = inp.value;
          });
        }
      };

      var validateAndSync = function (e) {
        if (toggle && toggle.checked) {
          var emailVal = emailInput ? emailInput.value.trim() : "";
          if (!emailVal || emailVal.indexOf("@") === -1) {
            if (e) {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
            }

            if (emailInput) {
              emailInput.focus();
              emailInput.style.borderColor = "#e53e3e";
              emailInput.style.boxShadow = "0 0 0 3px rgba(229, 62, 62, 0.2)";
            }

            if (errors) {
              errors.textContent = "Please enter a valid recipient email address.";
              errors.hidden = false;
              errors.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
            return false;
          } else {
            if (errors) errors.hidden = true;
            if (emailInput) {
              emailInput.style.borderColor = "";
              emailInput.style.boxShadow = "";
            }
          }
        }
        syncFormProperties();
      };

      form.addEventListener("submit", validateAndSync, true);

      var buyButtons = form.querySelectorAll("[name='add'], button[type='submit'], .product-form__btn");
      buyButtons.forEach(function (btn) {
        btn.addEventListener("click", validateAndSync, true);
      });
    }
  };

  var boot = function () {
    document.querySelectorAll("[data-gift-card-builder]").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
